import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { AlertDescriptionPipe } from '@monitor/alerting/pipes/alert-description.pipe';
import { MutedStationAlertsTooltipPipe } from '@monitor/alerting/pipes/muted-station-alerts-tooltip.pipe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AlertDashboardAlertComponent } from '@shared/components/alert-dashboard-alert/alert-dashboard-alert.component';
import { CookieBannerComponent } from '@shared/components/cookie-banner/cookie-banner.component';
import { FormElementComponent } from '@shared/components/form-element/form-element.component';
import { LogoPreviewComponent } from '@shared/components/logo-preview/logo-preview.component';
import { LogoSelectComponent } from '@shared/components/logo-select/logo-select.component';
import { TextWithTitleComponent } from '@shared/components/text-with-title/text-with-title.component';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';
import { MenuOverlayModule } from '@widgets/menu-overlay/menu-overlay.module';
import { WidgetModule } from '@widgets/widgets.module';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ChargingStationAssignmentsTablesComponent } from './components/charging-station-assignments-tables/charging-station-assignments-tables.component';
import { FooterComponent } from './components/footer/footer.component';
import { FooterModule } from './components/footer/footer.module';
import { GlobalHeaderComponent } from './components/header/global-header/global-header.component';
import { HeaderModule } from './components/header/header.module';
import { EopStationSearchFieldComponent } from './components/header/quick-access/eop-station-search-field/eop-station-search-field.component';
import { HighlightorComponent } from './components/highlightor/highlightor.component';
import { HtmlTooltipComponent } from './components/html-tooltip/html-tooltip.component';
import { NotificationTopComponent } from './components/notification-top/notification-top.component';
import { ScrollToTopComponent } from './components/scroll-to-top/scroll-to-top.component';
import { metaReducers } from './ngrx-meta-reducer/ngrx-meta.functions';
import { AidNamePipe } from './pipes/aid-name.pipe';
import { PipesModule } from './pipes/pipe.module';
import { SessionEffects } from './store/session.effects';
import { reducers } from './store/session.reducer';
import { SessionAlertDetails } from './components/alert-dashboard-alert/session-alert-details/session-alert-details';
import { AlertErrorCodeTranslationKeyPipe } from './pipes/alert-error-code-translation-key.pipe';
import { EopButtonModule } from '@widgets/eop-button/eop-button.module';
import { NoTariffInfoComponent } from './components/no-tariff-info/no-tariff-info.component';
import { SelectTariffComponent } from './components/select-tariff/select-tariff.component';
import { DropdownModule } from '@widgets/dropdown/dropdown.module';

@NgModule({
  imports: [
    StoreModule.forFeature('session', reducers, { metaReducers }),
    EffectsModule.forFeature([SessionEffects]),
    MatTooltipModule,
    InlineSVGModule,
    WidgetModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HeaderModule,
    FooterModule,
    PipesModule,
    SharedDirectivesModule,
    AlertDescriptionPipe,
    MutedStationAlertsTooltipPipe,
    AlertErrorCodeTranslationKeyPipe,
    MenuOverlayModule,
    RouterLink,
    EopButtonModule,
    DropdownModule,
  ],
  declarations: [
    ChargingStationAssignmentsTablesComponent,
    CookieBannerComponent,
    FormElementComponent,
    NotificationTopComponent,
    ScrollToTopComponent,
    HtmlTooltipComponent,
    HighlightorComponent,
    TextWithTitleComponent,
    LogoPreviewComponent,
    LogoSelectComponent,
    AlertDashboardAlertComponent,
    SessionAlertDetails,
    NoTariffInfoComponent,
    SelectTariffComponent,
  ],
  exports: [
    ChargingStationAssignmentsTablesComponent,
    CookieBannerComponent,
    FormElementComponent,
    NotificationTopComponent,
    ScrollToTopComponent,
    HtmlTooltipComponent,
    HighlightorComponent,
    TextWithTitleComponent,
    GlobalHeaderComponent,
    FooterComponent,
    LogoPreviewComponent,
    LogoSelectComponent,
    EopStationSearchFieldComponent,
    AlertDashboardAlertComponent,
    NoTariffInfoComponent,
    SelectTariffComponent,
  ],
  providers: [AidNamePipe],
})
export class SharedModule {}
